<template>
  <div class="main-factors-actions">
    <c-button
      v-if="record.comment.length > 0"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Результат удалённой работы',
        placement: 'top',
      }"
      class="main-factors-actions-comment"
      size="iconic"
      icon="comment"
      @click="isShowCommentModal = true"
    />

    <c-button
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: `Сохраненный расчет по филиалу <b>${record.placeOfWork.value}</b> за <b>${record.dateTime}</b>`,
        placement: 'top',
      }"
      class="c-table-actions-trash"
      size="iconic"
      icon="calculate"
      @click="goToCalculations()"
    />

    <b-modal
      id="main-factors-comment-from-employee"
      v-model="isShowCommentModal"
      class="main-factors-actions-comment-modal"
      centered
      hide-footer
      hide-header
    >
      <svg
        class="main-factors-actions-comment-modal-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="isShowCommentModal = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      {{ record.comment }}
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "c-table-actions",

  components: {
    "c-button": Button,
  },

  props: ["record"],

  data() {
    return {
      isShowCommentModal: false,
    };
  },

  methods: {
    goToCalculations() {
      const routeData = this.$router.resolve({ path: `/calculation/production?calc_id=${this.record.calculation_id}` });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.main-factors-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 66px;
  width: 100%;
  padding: 2px 7px;

  @media screen and (max-width: 700px) {
    justify-content: center;
    padding: 6px 10px;
  }

  &-comment {
    margin-right: 10px;

    ::v-deep & .c-button-icon {
      margin-left: -6px !important;
      margin-top: -7px !important;
    }
  }

  &-comment-modal {
    &-close {
      cursor: pointer;
      position: absolute;
      top: 13px;
      right: 12px;
    }
  }
}

#main-factors-comment-from-employee {
  .modal-dialog {
    max-width: 320px;
  }
}
</style>
